import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import DisplayCard from './DisplayCard';

const Block = (props) => {
  const { value, lable } = props.data;
  const {
    selectedBlockValue,
    handleChange,
    countValue,
    loading
  } = props;

  const [count, setCount] = useState(countValue);
  // const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    let result = value;
    if (selectedBlockValue !== result) {
      setSelected(false);
    } else {
      setSelected(true);
    }
    setCount(countValue)
  }, [selectedBlockValue, value, countValue]);

  const handleClick = () => {
    setSelected(true);
    handleChange(value);
  };

  // useEffect(() => {
  //   let data = {
  //     statusID: statusID,
  //     vendorMosymphonyID: CMOMember,
  //     searchByProductCode: productSearch,
  //     BSDStartDate: startDate,
  //     BSDEndDate: endDate,
  //   };
  //   axios
  //     .post(
  //       `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/quickSummaryCount`,
  //       data
  //     )
  //     .then((res) => {
  //       setLoading(false);
  //       setCount(res.data.data.statusCount.count);
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       console.log(err);
  //     });
  // }, [statusID, CMOMember, productSearch, startDate, endDate]);

  return (
    <DisplayCard
      tertiaryText={null}
      secondaryText={lable}
      primaryText={count}
      loading={loading}
      selected={selected}
      handleClick={handleClick}
    />
  );
};

export default Block;
